export default {
    getLookupData: "common/lookup-data",
    getLookupColor: "common/lookup-color-data",
    getLookup: "common/lookup-data/:type",
    normalizePhone: "common/normalize-phone",
    agendaType: "common/agendatypes",
    agendaStatus: "common/appointmentstatuss",
    purposes: "common/purposes",
    demandStatus: "common/demandStatus",
    objectGoals: "common/objectgoals",
    objectGoalsDetail: "common/objectgoals/:id",
    purposesDetail: "common/purposes/:id",
    getSites: "common/get-sites",
    mapOptions: "maps/options",
    mapRegions: "maps/regions",
    mapAddress: "maps/address",
    getAllSuggestPlace: "appointments/suggest-all-places",
    getLookupEmailByPropertyIds: "properties/relation-emails/:propertyIds",
    getGridConfigs: "common/grid-configs",
    getAppointmentconfig: "appointments/configs",
    getCurrentVersion: "common/current-version",
    getConsultedPerson: "persons/consulted-persons",
    getGridConfigsUsedUsers: "/common/grid-configs-used-users",
    lookUpData: "common/lookup-data/:type",
    globalSearch: "common/global-search",
    restoreObject: ":objectType/restore",
    configFormData: ":module/configs",
    getConfigByKey: "configurations/config-value",
    getPrefetchPropertyAgenda: "appointments/property/:id",
    getPrefetchPersonAgenda: "appointments/person/:id",
    getUserPhoneDevice: "phone/user-device",
    getPersonInfoByPhone: "phone/phone-number",
    makeCallWithPhoneNumber: "phone/quick-call",
    phonePermission: "configurations/user-configuration",
    phoneConfigs: "configurations/phone-configuration",
    callDetail: "phone/voip-incoming/:id",
    checkShouldShowVoipIncoming: "phone/voip-incoming/:id/should-show",
    largeMailingConfigs: "configurations/large-mailing",
    // notificationDetail: 'message-notifications/immovietnam/MessageNotification',
    notificationDetail:
        "message-notifications/:customer-name/MessageNotification",
    notificationPopupDetail:
        "message-notifications/MessageNotificationPopup/:id",
    advanceSearch: "common/global-search-advance",
    sendSMS: "persons/sms",
    getClientPhoneInfo: "phone/persons",
    translateMultiple: "api/translate/multiple/:customer",
    getLookupDataSupplier:
        "common/lookup-data-supplier/:supplierName/:dataTypes",
    getTelSmartActivateUrl: "phone/user-get-register-link/telsmart",
    getUnsubscribeTelSmartUrl: "phone/user-get-unsubscribe-link/telsmart",
    getCheckStatusTelSmart: "phone/user-used-phone-providers",
    configCloudCTI: "phone/user-register/cloudcti",
    unSubCloudCTI: "phone/user-unsubscribe/cloudcti",
    getAcaAuthorization: "common/get-aca-authorization",
    unitedKingdomFlag:
        "https://cdn.omnicasaassets.com/public/omnicasaresources/images/webapp/countries/gb.svg",
    franceFlag:
        "https://cdn.omnicasaassets.com/public/omnicasaresources/images/webapp/countries/fr.svg",
    netherlandsFlag:
        "https://cdn.omnicasaassets.com/public/omnicasaresources/images/webapp/countries/nl.svg",
    germanyFlag:
        "https://cdn.omnicasaassets.com/public/omnicasaresources/images/webapp/countries/de.svg",
    getDefaultPublishTypeByDocumentTypeId: "common/documenttypes/:id"
};
